interface RolePageData {
	// Common properties
	type: 'roleSection';
	role: string; // Which role this applies to

	// Role section data
	initialSection: {
		h1: string;
		pArray: string[];
		image: string;
		imageAlt: string;
		h2: string;
		buttonText?: string;
	};
	summarySection: {
		h3: string;
		p: string[];
	};
	faqSection: {
		title: string;
		faqs: {
			key: string;
			question: string;
			answer: string;
		}[];
	};
	candidateSection: {
		title: string;
		subtitle: string;
		candidates?: {
			imgSrc: string;
			imgAlt: string;
			name: string;
			role: string;
			skillsTag: string[];
			experience: string;
		}[];
	};
	squareCta: {
		cardText: string;
	};
}

export const rolePageData: RolePageData[] = [
	// Social media manager
	{
		type: 'roleSection',
		role: 'social-media-manager',
		initialSection: {
			h1: 'Hire a Social Media Manager from the Philippines direct',
			pArray: [
				'Permworks is a job board where you can hire Philippines talent direct',
				'Startups and large enterprises use Permworks to hire part-time or full-time staff',
				'No middleman fees, no markups, just top-tier talent you can hire directly with 24hrs',
			],
			image: '/images/initial-section/social-media-manager.png',
			imageAlt: 'Social media manager working on social media',
			h2: 'Join our team of innovative engineers',
			buttonText: 'Post a free job Ad',
		},
		candidateSection: {
			title: 'Our team of talented social media managers',
			subtitle: 'We are a team of experienced social media managers who are passionate about building engaging online presence',
			candidates: [
				{
					imgSrc: '/images/candidate-section/gabriel.png',
					imgAlt: 'Gabriel Paolo',
					name: 'Gabriel Paolo',
					role: 'Social Media Manager',
					skillsTag: ['Instagram', 'Facebook', 'Content Planning'],
					experience: '5+ years',
				},
				{
					imgSrc: '/images/candidate-section/harvey.png',
					imgAlt: 'Harvey Tuazon',
					name: 'Harvey Tuazon',
					role: 'Social Media Specialist',
					skillsTag: ['TikTok', 'LinkedIn', 'Analytics'],
					experience: '3+ years',
				},
				{
					imgSrc: '/images/candidate-section/jerry.png',
					imgAlt: 'Jerry Clark',
					name: 'Jerry Clark',
					role: 'Content Creator',
					skillsTag: ['Copywriting', 'Social Strategy', 'Canva'],
					experience: '5+ years',
				},
				{
					imgSrc: '/images/candidate-section/joan.png',
					imgAlt: 'Bernila Sanchez',
					name: 'Bernila Sanchez',
					role: 'Community Manager',
					skillsTag: ['Customer Engagement', 'Hootsuite', 'Analytics'],
					experience: '6+ years',
				},
			],
		},
		summarySection: {
			h3: 'A summary of the Social Media Manager market in the Philippines',
			p: [
				'Entry level salaries are 600 AUD per month (Employee) / 800 AUD per month (contractor).',
				'Mid level salaries are 900 AUD per month (Employee) / 1100 AUD per month (contractor).',
				'Senior level salaries are 1200 - 2000 AUD per month (Employee) / 1400 - 2200 AUD per month (contractor).',
				'A Social Media Manager in the Philippines can create, schedule, and manage content across platforms like Facebook, Instagram, and LinkedIn to grow your brand and engage your audience.',
			],
		},
		faqSection: {
			title: 'Frequently Asked Questions',
			faqs: [
				{
					key: '1',
					question: 'How do you find a Social Media Manager through Permworks?',
					answer: 'Post employers can recruit applicants with the focus of posting. You can hire directly to save money that the right fit.',
				},
				{
					key: '2',
					question: 'Are Social Media Managers in the Philippines experienced with global brands?',
					answer: 'Yes – many have experience working with US and UK agencies. Local SMM experts can create content across platforms like Facebook, Instagram, TikTok, and LinkedIn.',
				},
				{
					key: '3',
					question: 'Can I hire a Social Media Manager for part-time or project-based work?',
					answer: 'Absolutely. You can hire full-time, part-time, or one-off services based on your campaign needs and budget.',
				},
				{
					key: '4',
					question: 'How is hiring through Permworks different from using an agency or BPO?',
					answer: 'You connect with talent directly, pay them directly, and communicate directly – no layer of fees or third-party costs.',
				},
			],
		},
		squareCta: {
			cardText: 'Top Social Media Managers from the Philippines are in high demand',
		},
	},

	// Video editor
	{
		type: 'roleSection',
		role: 'video-editor',
		initialSection: {
			h1: 'Hire a Video Editor from the Philippines direct',
			pArray: [
				'Permworks is a job board where you can hire Philippines talent direct',
				'Startups and large enterprises use Permworks to hire part-time or full-time staff',
				'No middleman fees, no markups, just top-tier talent you can hire directly with 24hrs',
			],
			image: '/images/initial-section/video-editor.png',
			imageAlt: 'Video editor working on a video project',
			h2: 'Join our team of creative video professionals',
			buttonText: 'Post a free job Ad',
		},
		candidateSection: {
			title: 'Our team of talented video editors',
			subtitle: 'We are a team of experienced video editors who are passionate about creating engaging visual content',
			candidates: [
				{
					imgSrc: '/images/candidate-section/gabriel.png',
					imgAlt: 'Gabriel Paolo',
					name: 'Gabriel Paolo',
					role: 'Video Editor',
					skillsTag: ['Adobe Premiere', 'After Effects', 'Color Grading'],
					experience: '5+ years',
				},
				{
					imgSrc: '/images/candidate-section/harvey.png',
					imgAlt: 'Harvey Tuazon',
					name: 'Harvey Tuazon',
					role: 'Motion Graphics Designer',
					skillsTag: ['After Effects', 'Cinema 4D', 'Animation'],
					experience: '3+ years',
				},
				{
					imgSrc: '/images/candidate-section/jerry.png',
					imgAlt: 'Jerry Clark',
					name: 'Jerry Clark',
					role: 'Video Producer',
					skillsTag: ['Final Cut Pro', 'DaVinci Resolve', 'Sound Design'],
					experience: '5+ years',
				},
				{
					imgSrc: '/images/candidate-section/joan.png',
					imgAlt: 'Bernila Sanchez',
					name: 'Bernila Sanchez',
					role: 'Content Editor',
					skillsTag: ['Premiere Pro', 'Visual Effects', 'Storytelling'],
					experience: '6+ years',
				},
			],
		},
		summarySection: {
			h3: 'A summary of the Video Editor market in the Philippines',
			p: [
				'Entry level salaries are 600 AUD per month (Employee) / 800 AUD per month (contractor).',
				'Mid level salaries are 1000 AUD per month (Employee) / 1200 AUD per month (contractor).',
				'Senior level salaries are 1300 AUD per month (Employee) / 1500 AUD per month (contractor).',
				'A Video Editor in the Philippines can create, edit, and produce high-quality video content for your brand, social media, or marketing campaigns.',
			],
		},
		faqSection: {
			title: 'Frequently Asked Questions',
			faqs: [
				{
					key: '1',
					question: 'How do you find a Video Editor through Permworks?',
					answer: 'Post employers can recruit applicants with the focus of posting. You can hire directly to save money that the right fit.',
				},
				{
					key: '2',
					question: 'Are Video Editors in the Philippines experienced with international standards?',
					answer: 'Yes – many have experience working with global clients and can create professional video content across various styles and formats.',
				},
				{
					key: '3',
					question: 'Can I hire a Video Editor for part-time or project-based work?',
					answer: 'Absolutely. You can hire full-time, part-time, or one-off services based on your project needs and budget.',
				},
				{
					key: '4',
					question: 'What software are Video Editors in the Philippines familiar with?',
					answer: 'Most video editors are proficient in industry-standard software such as Adobe Premiere Pro, After Effects, Final Cut Pro, and DaVinci Resolve.',
				},
			],
		},
		squareCta: {
			cardText: 'Top Video Editors from the Philippines are in high demand',
		},
	},

	// Virtual Assistant
	{
		type: 'roleSection',
		role: 'virtual-assistant',
		initialSection: {
			h1: 'Hire a Virtual Assistant from the Philippines direct',
			pArray: [
				'Permworks is a job board where you can hire Philippines talent direct',
				'Startups and large enterprises use Permworks to hire part-time or full-time staff',
				'No middleman fees, no markups, just top-tier talent you can hire directly with 24hrs',
			],
			image: '/images/initial-section/virtual-assistant.png',
			imageAlt: 'Virtual assistant working on administrative tasks',
			h2: 'Join our team of professional virtual assistants',
			buttonText: 'Post a free job Ad',
		},
		candidateSection: {
			title: 'Our team of talented virtual assistants',
			subtitle: 'We are a team of experienced virtual assistants who are dedicated to providing efficient administrative support',
			candidates: [
				{
					imgSrc: '/images/candidate-section/gabriel.png',
					imgAlt: 'Gabriel Paolo',
					name: 'Gabriel Paolo',
					role: 'Executive Assistant',
					skillsTag: ['Calendar Management', 'Email', 'CRM'],
					experience: '5+ years',
				},
				{
					imgSrc: '/images/candidate-section/harvey.png',
					imgAlt: 'Harvey Tuazon',
					name: 'Harvey Tuazon',
					role: 'Administrative Assistant',
					skillsTag: ['Data Entry', 'Scheduling', 'Customer Service'],
					experience: '3+ years',
				},
				{
					imgSrc: '/images/candidate-section/jerry.png',
					imgAlt: 'Jerry Clark',
					name: 'Jerry Clark',
					role: 'Virtual Assistant',
					skillsTag: ['Office Admin', 'Research', 'Bookkeeping'],
					experience: '5+ years',
				},
				{
					imgSrc: '/images/candidate-section/joan.png',
					imgAlt: 'Bernila Sanchez',
					name: 'Bernila Sanchez',
					role: 'Project Coordinator',
					skillsTag: ['Task Management', 'Client Support', 'Documentation'],
					experience: '6+ years',
				},
			],
		},
		summarySection: {
			h3: 'A summary of the Virtual Assistant market in the Philippines',
			p: [
				'Entry level salaries are 600 AUD per month (Employee) / 800 AUD per month (contractor).',
				'Mid level salaries are 1000 AUD per month (Employee) / 1200 AUD per month (contractor).',
				'Senior level salaries are 1300 AUD per month (Employee) / 1500 AUD per month (contractor).',
				'A Virtual Assistant in the Philippines can handle administrative tasks, email management, calendar scheduling, data entry, customer support, and other essential business operations.',
			],
		},
		faqSection: {
			title: 'Frequently Asked Questions',
			faqs: [
				{
					key: '1',
					question: 'How do you find a Virtual Assistant through Permworks?',
					answer: 'Post employers can recruit applicants with the focus of posting. You can hire directly to save money that the right fit.',
				},
				{
					key: '2',
					question: 'What tasks can a Filipino Virtual Assistant handle?',
					answer: 'Filipino VAs can manage calendars, handle email, provide customer support, manage social media, process data, research, book travel, and handle many other administrative tasks to support your business.',
				},
				{
					key: '3',
					question: 'Can I hire a Virtual Assistant for part-time work?',
					answer: 'Absolutely. You can hire full-time, part-time, or task-based services based on your business needs and budget.',
				},
				{
					key: '4',
					question: 'Do Virtual Assistants in the Philippines speak good English?',
					answer: 'Yes – The Philippines has one of the highest English proficiency rates in Asia. Most VAs are fluent in English and can communicate professionally with clients and customers worldwide.',
				},
			],
		},
		squareCta: {
			cardText: 'Top Virtual Assistants from the Philippines are in high demand',
		},
	},

	// Security Analyst
	{
		type: 'roleSection',
		role: 'security-analyst',
		initialSection: {
			h1: 'Hire a Security Analyst from the Philippines direct',
			pArray: [
				'Permworks is a job board where you can hire Philippines talent direct',
				'Startups and large enterprises use Permworks to hire part-time or full-time staff',
				'No middleman fees, no markups, just top-tier talent you can hire directly with 24hrs',
			],
			image: '/images/initial-section/security-analyst.png',
			imageAlt: 'Security analyst monitoring cyber security systems',
			h2: 'Join our team of skilled security professionals',
			buttonText: 'Post a free job Ad',
		},
		candidateSection: {
			title: 'Our team of talented security analysts',
			subtitle: 'We are a team of experienced security analysts who are dedicated to protecting your digital assets and infrastructure',
			candidates: [
				{
					imgSrc: '/images/candidate-section/gabriel.png',
					imgAlt: 'Gabriel Paolo',
					name: 'Gabriel Paolo',
					role: 'Security Analyst',
					skillsTag: ['Penetration Testing', 'SIEM', 'Risk Assessment'],
					experience: '5+ years',
				},
				{
					imgSrc: '/images/candidate-section/harvey.png',
					imgAlt: 'Harvey Tuazon',
					name: 'Harvey Tuazon',
					role: 'Cybersecurity Specialist',
					skillsTag: ['Incident Response', 'Threat Intelligence', 'NIST'],
					experience: '3+ years',
				},
				{
					imgSrc: '/images/candidate-section/jerry.png',
					imgAlt: 'Jerry Clark',
					name: 'Jerry Clark',
					role: 'Security Engineer',
					skillsTag: ['Network Security', 'Firewall', 'Vulnerability Scanning'],
					experience: '5+ years',
				},
				{
					imgSrc: '/images/candidate-section/joan.png',
					imgAlt: 'Bernila Sanchez',
					name: 'Bernila Sanchez',
					role: 'Compliance Specialist',
					skillsTag: ['ISO 27001', 'GDPR', 'Security Audits'],
					experience: '6+ years',
				},
			],
		},
		summarySection: {
			h3: 'A summary of the Security Analyst market in the Philippines',
			p: [
				'Entry level salaries are 800 AUD per month (Employee) / 1000 AUD per month (contractor).',
				'Mid level salaries are 2000 AUD per month (Employee) / 2200 AUD per month (contractor).',
				'Senior level salaries are 3000 - 4000 AUD per month (Employee) / 3500 - 4500 AUD per month (contractor).',
				"A Security Analyst in the Philippines can monitor systems for security breaches, implement security measures, conduct vulnerability assessments, and develop strategies to protect your organization's digital infrastructure.",
			],
		},
		faqSection: {
			title: 'Frequently Asked Questions',
			faqs: [
				{
					key: '1',
					question: 'How do you find a Security Analyst through Permworks?',
					answer: 'Post employers can recruit applicants with the focus of posting. You can hire directly to save money that the right fit.',
				},
				{
					key: '2',
					question: 'What qualifications do Security Analysts in the Philippines typically have?',
					answer: 'Many Filipino Security Analysts hold industry certifications such as CompTIA Security+, CEH, CISSP, or CISM, along with degrees in cybersecurity, IT, or computer science.',
				},
				{
					key: '3',
					question: 'Can I hire a Security Analyst for specific security projects?',
					answer: 'Yes. You can hire for full-time roles, part-time positions, or specific security projects such as vulnerability assessments, security audits, or system hardening.',
				},
				{
					key: '4',
					question: 'How experienced are Security Analysts in the Philippines with international security standards?',
					answer: 'Many Filipino Security Analysts have experience working with global companies and are knowledgeable about international security frameworks and compliance standards such as ISO 27001, NIST, GDPR, and PCI DSS.',
				},
			],
		},
		squareCta: {
			cardText: 'Top Security Analysts from the Philippines are in high demand',
		},
	},
];
